import React from "react";

const Image = React.forwardRef<
  HTMLImageElement,
  React.ImgHTMLAttributes<HTMLImageElement> & { src: string; alt: string; fill?: boolean; priority?: boolean }
>(({ fill, priority, ...props }, ref) => <img ref={ref} {...props} />);

Image.displayName = "Image";

export default Image;
